export const projects = [
  {
    title: "Python Flask App",
    subtitle: "Python Microframework",
    description:
      "A website for a carpentry business created using the Python Flask microframework and hosted on Heroku",
    image: "./jpsupperdeckwebsite.gif",
    link: "https://www.jpsupperdeck.com/",
  },
  {
    title: "Python Flask App",
    subtitle: "Python Microframework",
    description:
      "A website for a recruitment company that allows the owner to log in and add and remove job postings using the Python Flask microframework and hosted on Heroku",
    image: "./massbaystaffingwebsite.gif",
    link: "https://www.massbaystaffing.com/",
  },
  {
    title: "Corvi Invaders",
    subtitle: "Python Game",
    description:
      "A Python game created using the pyglet library",
    image: "./corvi_invaders_game.gif",
    link: "https://github.com/dcorvi/corvi_invaders",
  },
  {
    title: "R Packages",
    subtitle: "Big Data Report Automation",
    description:
      "Leveraging R packages and R Markdown to automate the reporting of spatial socioeconomic data for offshore wind projects",
    image: "./r_offshorewind.gif",
    link: "https://www.fisheries.noaa.gov/resource/data/socioeconomic-impacts-atlantic-offshore-wind-development",
  },
  // {
  //   title: "Geospatial Analysis",
  //   subtitle: "ArcGIS - QGIS - RGDAL",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-2.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "DevChat",
  //   subtitle: "React and Firebase",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-3.gif",
  //   link: "https://www.massbaystaffing.com/",
  // },
  // {
  //   title: "Epic Todo App",
  //   subtitle: "React Hooks",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-4.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "Python Data Mining",
  //   subtitle: "Extrating Data from Twitter, Linkedin",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-1.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "API Building",
  //   subtitle: "Postman, Requests, RESTful",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-2.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "Mobile App Development",
  //   subtitle: "React Native",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-3.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "Python Game",
  //   subtitle: "Space Invaders with Sound",
  //   description:
  //     "Recreating the classic video game using Python and hosting it in a Docker container",
  //   image: "./project-4.gif",
  //   link: "https://twit-ecommerce4.herokuapp.com/",
  // },
  // {
  //   title: "React Reserve",
  //   subtitle: "MERN Stack",
  //   description:
  //     "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium dolore rerum laborum iure enim sint nemo omnis voluptate exercitationem eius?",
  //   image: "./project-1.gif",
  //   link: "https://jobsboard-neafj-frontend.herokuapp.com/",
  // },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "R & R Packages",
  "Oracle & SQL",
  "Python & Flask",
  "JavaScript & React",
  "Geospatial Analysis",
  "GitHub",
  "Markdown & LaTeX",
  "Mobile Apps",
  "API Building",
  // "AWS",
  // Jira,
  "Docker & Heroku",
];



// WEBPACK FOOTER //
// ./src/data.js